export default "__VITE_ASSET__BdiLdjZd__"